import {
  BookingActionTypes,
  BookingState,
  CONFIRM_BOOKING_FAILURE,
  CONFIRM_BOOKING_INIT,
  CONFIRM_BOOKING_SUCCESS,
  CREATE_BOOKING_FAILURE,
  CREATE_BOOKING_INIT,
  CREATE_BOOKING_SUCCESS,
  DELETE_BOOKING,
  DELETE_PAYMENT,
  DELETE_REVISION,
  EDIT_BOOKING,
  GET_BOOKING_REVISIONS_SUCCESS,
  GET_BOOKINGS_FAILURE,
  GET_BOOKINGS_INIT,
  GET_BOOKINGS_SUCCESS,
  GET_PAYMENTS_FAILURE,
  GET_PAYMENTS_INIT,
  GET_PAYMENTS_SUCCESS,
  LOAD_EDITABLE_BOOKING,
  MAKE_PAYMENT_FAILURE,
  MAKE_PAYMENT_INIT,
  MAKE_PAYMENT_SUCCESS,
  RESET_BOOKING,
  REVISE_BOOKING_FAILURE,
  REVISE_BOOKING_INIT,
  REVISE_BOOKING_SUCCESS,
  SET_EDITING_BOOKING,
  SUBMIT_PROPOSAL_FAILURE,
  SUBMIT_PROPOSAL_INIT,
  SUBMIT_PROPOSAL_SUCCESS
} from "./types";

const initialState: BookingState = {
  editingBooking: false,
  editableBooking: null,
  bookings: {},
  revisions: {},
  payments: {},
  isGettingBookings: false,
  successGettingBookings: false,
  errorGettingBookings: null,
  isCreatingBooking: false,
  successCreatingBooking: false,
  errorCreatingBooking: null,
  isRevisingBooking: false,
  successRevisingBooking: false,
  errorRevisingBooking: null,
  isSubmittingProposal: false,
  successSubmittingProposal: false,
  errorSubmittingProposal: null,
  isConfirmingBooking: false,
  successConfirmingBooking: false,
  errorConfirmingBooking: null,
  isGettingPayments: false,
  successGettingPayments: false,
  errorGettingPayments: null,
  isMakingPayment: false,
  successMakingPayment: false,
  errorMakingPayment: null
};

export default function appReducer(
  state = initialState,
  action: BookingActionTypes
) {
  switch (action.type) {
    case SET_EDITING_BOOKING:
      return {
        ...state,
        editingBooking: action.editing
      };
    case LOAD_EDITABLE_BOOKING:
      return {
        ...state,
        editableBooking: action.booking
      };
    case EDIT_BOOKING:
      return {
        ...state,
        editableBooking: {
          ...state.editableBooking,
          ...action.changes
        }
      };
    case GET_BOOKINGS_INIT:
      return {
        ...state,
        isGettingBookings: true,
        successGettingBookings: false,
        errorGettingBookings: null
      };
    case GET_BOOKINGS_SUCCESS:
      return {
        ...state,
        isGettingBookings: false,
        successGettingBookings: true,
        bookings: {
          ...state.bookings,
          ...action.bookings
        }
      };
    case GET_BOOKING_REVISIONS_SUCCESS:
      return {
        ...state,
        revisions: {
          ...state.revisions,
          [action.bookingId]: {
            ...state.revisions[action.bookingId],
            ...action.revisions
          }
        }
      };
    case GET_BOOKINGS_FAILURE:
      return {
        ...state,
        isGettingBookings: false,
        successGettingBookings: false,
        errorGettingBookings: action.error
      };
    case DELETE_BOOKING:
      const newBookings = Object.assign({}, state.bookings);
      delete newBookings[action.bookingId];

      return {
        ...state,
        bookings: newBookings
      };
    case DELETE_REVISION:
      const newBookingRevisions = Object.assign(
        {},
        state.revisions[action.bookingId]
      );
      delete newBookingRevisions[action.bookingId][action.revisionId];

      return {
        ...state,
        revisions: newBookingRevisions
      };
    case CREATE_BOOKING_INIT:
      return {
        ...state,
        isCreatingBooking: true,
        successCreatingBooking: false,
        errorCreatingBooking: null
      };
    case CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        isCreatingBooking: false,
        successCreatingBooking: true,
        errorCreatingBooking: null
      };
    case CREATE_BOOKING_FAILURE:
      return {
        ...state,
        isCreatingBooking: false,
        successCreatingBooking: false,
        errorCreatingBooking: action.error
      };
    case REVISE_BOOKING_INIT:
      return {
        ...state,
        isRevisingBooking: true
      };
    case REVISE_BOOKING_SUCCESS:
      return {
        ...state,
        isRevisingBooking: false,
        successRevisingBooking: true
      };
    case REVISE_BOOKING_FAILURE:
      return {
        ...state,
        isRevisingBooking: false,
        successRevisingBooking: false,
        errorRevisingBooking: action.error
      };
    case SUBMIT_PROPOSAL_INIT:
      return {
        ...state,
        isSubmittingProposal: true
      };
    case SUBMIT_PROPOSAL_SUCCESS:
      return {
        ...state,
        isSubmittingProposal: false,
        successSubmittingProposal: true
      };
    case SUBMIT_PROPOSAL_FAILURE:
      return {
        ...state,
        isSubmittingProposal: false,
        successSubmittingProposal: false,
        errorSubmittingProposal: action.error
      };
    case CONFIRM_BOOKING_INIT:
      return {
        ...state,
        isConfirmingBooking: true,
        successConfirmingBooking: false,
        errorConfirmingBooking: null
      };
    case CONFIRM_BOOKING_SUCCESS:
      return {
        ...state,
        isConfirmingBooking: false,
        successConfirmingBooking: true,
        errorConfirmingBooking: null
      };
    case CONFIRM_BOOKING_FAILURE:
      return {
        ...state,
        isConfirmingBooking: false,
        successConfirmingBooking: false,
        errorConfirmingBooking: action.error
      };
    case GET_PAYMENTS_INIT:
      return {
        ...state,
        isGettingPayments: true,
        successGettingPayments: false,
        errorGettingPayments: null
      };
    case GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        isGettingPayments: false,
        successGettingPayments: true,
        payments: {
          ...state.payments,
          ...action.payments
        },
        errorGettingPayments: null
      };
    case GET_PAYMENTS_FAILURE:
      return {
        ...state,
        isGettingPayments: false,
        successGettingPayments: false,
        errorGettingPayments: action.error
      };
    case DELETE_PAYMENT:
      const newPayments = Object.assign({}, state.payments);
      delete newPayments[action.paymentId];

      return {
        ...state,
        payments: newPayments
      };
    case MAKE_PAYMENT_INIT:
      return {
        ...state,
        isMakingPayment: true,
        successMakingPayment: false,
        errorMakingPayment: null
      };
    case MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        isMakingPayment: false,
        successMakingPayment: true,
        errorMakingPayment: null
      };
    case MAKE_PAYMENT_FAILURE:
      return {
        ...state,
        isMakingPayment: false,
        successMakingPayment: false,
        errorMakingPayment: action.error
      };

    case RESET_BOOKING:
      return initialState;

    default:
      return state;
  }
}
